import { clueTopics } from '@/mocks/cg51';
import SectionHeading from './SectionHeading';

const stages = [
  { key: '线索', desc: '原始碎片' },
  { key: '交叉', desc: '来源互证中' },
  { key: '实锤', desc: '多源命中' },
  { key: '复盘', desc: '已归档' },
];

export default function ClueIndex() {
  return (
    <section id="index" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHeading
          overline="线索索引"
          title="所有讨论，从这里进"
          note="一页看全当前正在追踪的分区。每条索引都标注了所处阶段与积累量，方便你按兴趣直接切入，而不是淹没在碎片里。"
        />

        <div className="mx-auto mb-8 max-w-3xl md:mb-10">
          <div className="flex flex-wrap items-center justify-center gap-2">
            {stages.map((s, i) => (
              <div key={s.key} className="flex items-center gap-2">
                <span className="inline-flex items-center gap-1.5 rounded-full border border-background-200 bg-background-100 px-3 py-1.5 text-xs font-medium whitespace-nowrap text-foreground-700">
                  <i className="ri-circle-fill text-[6px] text-secondary-600" />
                  {s.key}
                  <span className="text-foreground-500">· {s.desc}</span>
                </span>
                {i < stages.length - 1 && <i className="ri-arrow-right-line text-xs text-foreground-400" />}
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 md:gap-6 sm:grid-cols-2">
          {clueTopics.map((topic) => (
            <a
              key={topic.name}
              href="#index"
              className="group flex items-center justify-between rounded-lg border border-background-200/70 bg-background-100 px-4 py-4 transition-colors hover:border-primary-200 md:px-5 md:py-5"
            >
              <div className="flex items-center gap-3.5">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-200/70 text-foreground-800">
                  <i className="ri-chat-3-line text-lg" />
                </span>
                <div>
                  <div className="flex items-center gap-2">
                    <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-700">
                      {topic.name}
                    </h3>
                    {topic.hot && (
                      <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 px-2 py-0.5 text-[11px] font-semibold whitespace-nowrap text-primary-700">
                        <i className="ri-fire-fill text-xs" />
                        热
                      </span>
                    )}
                  </div>
                  <p className="mt-0.5 text-xs text-foreground-500">{topic.count} 条相关记录</p>
                </div>
              </div>
              <i className="ri-arrow-right-line text-lg text-foreground-400 transition-transform group-hover:translate-x-0.5 group-hover:text-primary-600" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}